import styled from "styled-components";

const Title = styled.p`
  font-family: FZLTZHK--GBK1-0, FZLTZHK--GBK1;
  font-weight: normal;
  color: rgba(236, 33, 179, 1);
  text-shadow: calc(1rem / 100) calc(1rem / 100) calc(0rem / 100)
    rgba(255, 255, 255, 1);
  text-align: center;
`;

export const TipWrapper = styled.div`
  position: relative;
  height: calc(142rem / 100);
  overflow: visible;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  * {
    z-index: 1;
  }
  .detail-info {
    font-size: calc(14rem / 100);
    font-family: FZLTZHK--GBK1-0, FZLTZHK--GBK1;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    line-height: calc(20rem / 100);
    text-align: center;
    &.edit-mode {
      box-sizing: content-box;
      min-height: 0.2rem;
      margin-left: auto;
      margin-right: auto;
      max-width: calc(360rem / 100);
      border: 2px dotted rgba(55, 112, 250, 1);
      animation-name: twinkle;
      padding: 0 0.1rem;
    }
  }
  .detail-info + .detail-info {
    margin-top: calc(8rem / 100);
  }
`;

export const MainTitle = styled(Title)`
  font-size: calc(36rem / 100);
  line-height: calc(41rem / 100);
  margin: calc(12rem / 100) auto calc(22rem / 100);
  max-width: calc(300rem / 100);
  padding: 0 0.1rem;
  &.edit-mode {
    border: 2px dotted rgba(55, 112, 250, 1);
    animation-name: twinkle;
    min-height: .42rem;
  }
  input {
    font-weight: normal;
  }
`;
export const SubTitle = styled(Title)`
  font-size: calc(22rem / 100);
  line-height: calc(26rem / 100);
  margin: calc(32rem / 100) auto 0;
  max-width: calc(300rem / 100);
  min-height: 0.28rem;
  padding: 0 0.1rem;
  &.edit-mode {
    border: 2px dotted rgba(55, 112, 250, 1);
    animation-name: twinkle;
  }
  input {
    font-weight: normal;
  }
`;
